import { render, staticRenderFns } from "./ModalAddCust.vue?vue&type=template&id=84379b18&scoped=true"
import script from "./ModalAddCust.vue?vue&type=script&lang=js"
export * from "./ModalAddCust.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCust.vue?vue&type=style&index=0&id=84379b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84379b18",
  null
  
)

export default component.exports